import { render, staticRenderFns } from "./BindsArrowDownIcon.vue?vue&type=template&id=da219a56&"
import script from "./BindsArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./BindsArrowDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports